export default "/images/printer_receipt.jpg?1047c25700f83e92c9db6083c534dafe";